module.exports = __webpack_public_path__ + "img/sub_success.c0e2091e.svg";